
<template>
  <!--新增封禁-->
  <x-addEdit
    apiOrigin="PHP"
    ref="addEdit"
    :reqLoading="reqLoading"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect, expireTime } from '../../../utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  mixins: [fetchSelect, addEdit, expireTime],
  name: 'addBan',
  data () {
    return {
      queryParam: '',
      reqLoading: {loading: false},
      formList: [
        {
          label: '账号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          props: ['mobile_phone', {
            rules: [
              { required: true, message: '请输入手机号' },
              { pattern: this.REG.mobile, message: this.MESSAGE.mobile }
            ]
          }]
        },
        {
          label: '封禁类型',
          inputType: 'select',
          options: [
            { label: '禁言', value: '1' },
            { label: '禁止发布动态', value: '2' }
          ],
          placeholder: '请选择封禁类型',
          handle: this.banTypeChange,
          props: ['type', {
            rules: [{ required: true, message: '请选择封禁类型' }]
          }]
        },
        {
          label: '封禁原因',
          inputType: 'select',
          options: [],
          placeholder: '请选择封禁原因',
          props: ['chat_category_id', {
            rules: [{ required: true, message: '请选择封禁原因' }]
          }]
        },
        {
          label: '封禁截止时间',
          inputType: 'input',
          options: [],
          placeholder: '单位为分钟，最大43200分钟',
          props: ['end_time', this.endTime()]
        }
      ],
      formKey: {
        mobile_phone: undefined,
        type: undefined,
        chat_category_id: undefined,
        end_time: undefined
      },
      addParam: {
        url: '/chat/forbidden',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '',
        resHandle: '' // this.resHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    this.handleForm();
  },
  methods: {
    /** 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/category/forbidden_select',
        params: {}
      }).then(({data}) => {
        this.formList[1].options = data.type;
      });
    },
    handleForm () {
      /** 聊天账号跳转链接新增封禁传手机号即可，投诉处理过了的要传手机号和 chat_complaint_id */
      this.queryParam = this.$route.query;
      if (this.queryParam.mobile) {
        this.userId = this.queryParam.userId;
        if (this.queryParam.route === 'chatAccount') {
          this.formList[0].disabled = true;
        } else {
          this.formList[0].disabled = true;
          this.formList[1].disabled = true;
        }

        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue({
            mobile_phone: this.queryParam.mobile,
            type: parseInt(this.queryParam.complaintType)
          });
          this.banTypeChange(this.queryParam.complaintType);
        });
      }
    },
    banTypeChange (e) {
      this.$refs.addEdit.form.resetFields(['chat_category_id']);
      this.formList[2].options = [];

      this._get({
        url: '/chat/forbidden/selectlist',
        params: { type: e }
      }).then(({data}) => {
        this.formList[2].options = data.category;
      });
    },
    resHandle (res) {
      return {};
    },
    reqHandle (param) {
      if (!this.queryParam.mobile) {
        return param;
      } else {
        this.handleSubmit();
      }
    },
    /** 自定义提交 */
    handleSubmit () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) { return; }
        this._post({
          url: '/chat/forbidden',
          params: {
            ...values,
            chat_user_id: this.queryParam.userId,
            chat_complaint_id: this.queryParam.complaintId
          },
          btnLoading: this.reqLoading
        }).then(({data}) => {
          this.$message.success('新增成功');
          if (this.queryParam.complaintId) {
            this.$router.go(-2);
          } else {
            this.$router.go(-1);
          }
        });
      });
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
